import React, { useState, useEffect } from 'react';
import { authService } from '../services/authService';
import { teamService } from '../services/teamService';
import Sidebar from './dashboard/Sidebar';
import Header from './dashboard/Header';
import Overview from './dashboard/Overview';
import AppointmentManagement from './dashboard/AppointmentManagement';
import TeamManagement from './dashboard/TeamManagement';
import AdvancedAnalytics from './dashboard/AdvancedAnalytics';
import ProfileManagement from './dashboard/ProfileManagement';
import TeamMemberDashboard from './TeamMemberDashboard';

const Dashboard = ({ onLogout }) => {
  const [activeSection, setActiveSection] = useState('overview');
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [userType, setUserType] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if admin is logged in
    const adminUser = authService.getCurrentUser();
    const teamMember = teamService.getCurrentUser();

    if (adminUser) {
      setCurrentUser(adminUser);
      setUserType('admin');
    } else if (teamMember) {
      setCurrentUser(teamMember);
      setUserType('team_member');
    } else {
      // No valid session found, redirect to login
      if (onLogout) {
        onLogout();
      }
    }
    setIsLoading(false);
  }, [onLogout]);

  const handleLogout = () => {
    if (userType === 'admin') {
      authService.logout();
    } else if (userType === 'team_member') {
      teamService.logout();
    }
    if (onLogout) {
      onLogout();
    }
  };

  // Loading state
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  // If no user found, return null (App.jsx will handle redirect)
  if (!currentUser) {
    return null;
  }

  // If team member, show team member dashboard
  if (userType === 'team_member') {
    return <TeamMemberDashboard />;
  }

  // Admin dashboard
  const renderContent = () => {
    switch (activeSection) {
      case 'overview':
        return <Overview />;
      case 'appointments':
        return <AppointmentManagement />;
      case 'team':
        return <TeamManagement />;
      case 'analytics':
        return <AdvancedAnalytics />;
      case 'profile':
        return <ProfileManagement />;
      default:
        return <Overview />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <Sidebar
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        onLogout={handleLogout}
      />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header 
          currentUser={currentUser}
          onLogout={handleLogout}
        />
        
        <main className="flex-1 overflow-auto">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default Dashboard;